// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + ({"134":"chunk_layerswipe","150":"chunk_metadatasearch","385":"chunk_featuredata","874":"chunk_maplegend"}[chunkId] || chunkId) + "/oskari.min.js";
};